import type { ApiMeta } from "@/apis/types";

/**
 * API metadata for WSDOT Commercial Vehicle Restrictions API
 */
export const wsdotCommercialVehicleRestrictionsApiMeta: ApiMeta = {
  name: "wsdot-commercial-vehicle-restrictions",
  baseUrl:
    "https://www.wsdot.wa.gov/traffic/api/cvrestrictions/cvrestrictionsrest.svc",
};
